import { h } from 'preact';
import React from 'react';

import { RowSettings } from './RowSettings';
import Children from '../../messages/Notice/Children';

import './Row.css';

export const Row = ({
  component,
  width,
  preview,
  dev,
  path,
  makeChoice,
  siteId,
  message,
  events
}) => {
  const settings = new RowSettings(component.settings);

  const styles = {
    ...settings.padding,
    ...settings.margin,
    ...settings.border,
    display: settings.display
  };

  /* WIDTH & HEIGHT */
  const { paddingLeft, paddingRight } = settings.padding;
  const { marginLeft, marginRight } = settings.margin;
  styles.width = settings.width.type === 'auto' ? 'auto' : settings.width.value + settings.width.type;
  styles.height = settings.height.type === 'auto' ? 'auto' : settings.height.value + settings.height.type;
  if (settings.width.type === '%') {
    styles.width = `calc(${settings.width.value}% - ${(paddingLeft + paddingRight + marginLeft + marginRight)}px`
  };

  /* OTHER SETTINGS */
  styles.background = settings.background;
  styles.justifyContent = settings.align;
  styles.alignItems = settings.vertical;

  /* RESPONSIVE SETTINGS */
  if (width && width < 600 && !preview) {
    styles.flexDirection = 'column';
    styles.justifyContent = settings.vertical;
    styles.alignItems = settings.align;
  }

  /* DEV MODE ONLY */
  let devActions = {};
  let devClass = '';
  path = JSON.stringify(path);
  if (dev) {
    devActions = { ...dev.hover };
    if (!dev.opts.hideRowColumnBorders) devClass += ' on-dev';
    if (dev.current === path) devClass += ' on-active';
    if (component.children.length === 0) styles.minHeight = '24px';
  };

  return (
    <div
      className={'message-component message-row' + devClass}
      path={path}
      style={styles}
      {...devActions}
    >
      {Children({
        path: JSON.parse(path),
        dev,
        components: component.children,
        siteId,
        message,
        makeChoice,
        events
      })}
    </div>
  );
}